module.exports = "/lucky-balls/img/drum/drum_loop_006.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/img/drum/drum_loop_006.png
// module id = 1021
// module chunks = 0